@let s = pageState();
@if (s.kind === 'pending') {
  <div class="bg-slate-50 min-h-screen" aria-busy="true" aria-live="polite">
    <app-marketing-header variant="home" />
    <div class="cg-container--marketing flex flex-col items-center justify-center gap-4 py-24 text-slate-500">
      <span
        class="h-10 w-10 animate-spin rounded-full border-2 border-slate-300 border-t-slate-700"
        aria-hidden="true"
      ></span>
      <p class="text-sm">Loading…</p>
    </div>
  </div>
} @else if (s.kind === 'error') {
  <div class="cg-container--marketing py-16 text-center">
    <h1 class="text-xl font-semibold text-slate-800">Blogs unavailable</h1>
    <p class="mt-3 max-w-lg mx-auto text-slate-600">Ensure the API is running.</p>
    <a routerLink="/" class="cg-mkt-btn cg-mkt-btn--primary mt-6 inline-block">Back to home</a>
  </div>
} @else {
  <div class="bg-slate-50 min-h-screen">
    <app-marketing-header variant="home" />
    <main class="cg-mkt-list-page cg-mkt-list-page--blogs">
      <div class="cg-container--marketing">
        <app-marketing-section-heading
          eyebrow="Student Resources"
          title="Study Abroad Blog"
          subtitle="Expert guides on visas, scholarships, universities, and your global career path."
        />
        @if (s.page.items.length === 0) {
          <p class="cg-mkt-list-page__empty">No blog posts published yet.</p>
        } @else {
          <div class="cg-blog-grid">
            @for (item of s.page.items; track item.slug) {
              <app-marketing-blog-card [post]="item" />
            }
          </div>
        }
      </div>
    </main>
    <app-marketing-footer />
  </div>
}
